import type { IssueDescriptionFields } from '@features/page/config/issue-description-fields'
import { OptionalIndicator } from '@shared/ui/form-label-indicators'
import { FormField, FormHelper, FormInputGroup, FormLabel, TextInput } from '@vp/swan'
import type { Control } from 'react-hook-form'
import { Controller } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

interface Props {
  control: Control<IssueDescriptionFields>
}

export const WebsiteDomainField = ({ control }: Props) => {
  const { t } = useTranslation()
  return (
    <FormField data-testid="website-domain-field">
      <FormLabel>
        {t('contact_us.page.steps.issue_description.website_issue_label')}
        <OptionalIndicator />
      </FormLabel>
      <Controller
        name="websiteDomain"
        control={control}
        rules={{ required: false }}
        render={({ field }) => (
          <FormInputGroup>
            <TextInput
              type="url"
              inputMode="url"
              data-testid="website-domain-input"
              placeholder={t('contact_us.page.steps.issue_description.website_issue_placeholder')}
              {...field}
            />
            <FormHelper>{t('contact_us.page.steps.issue_description.website_helper')}</FormHelper>
          </FormInputGroup>
        )}
      />
    </FormField>
  )
}
